<template>
    <div style=";" v-loading="page_loading">

        <el-row :gutter="10" style="margin-top: 10px">
            <el-col :span="24">
                <el-card style="color: #409EFF">
                    <div>
                        <i class="el-icon-s-cooperation"/>当前项目
                        <el-dropdown split-button type="primary" trigger="click" @command="handleCommand">
                            {{ projectName }}
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="index" v-for="(item,index) in project" :key="index">{{
                                        item.projectName
                                    }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        {{ projectAddress }}

                        <!--                        <i class="el-icon-s-shop" style="float: right" @click="show()">大屏显示</i>-->

                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="10" style="margin-bottom: 20px;margin-top: 10px">
            <el-col :span="12">
                <el-card style="color: #409EFF">
                    <div
                        style="margin-bottom: 20px;text-align: center;border-bottom: 1px solid #409EFF;padding:0 0 10px 0">
                        <i class="el-icon-s-promotion" style="float: left;font-size: 22px"/>
                        <span>历史耗能</span>
                        <!--                        <i class="el-icon-refresh" style="float: right !important;font-size: 22px"/>-->
                    </div>

                    <div style="padding: 10px 0;  font-weight: bold">
                        <el-radio-group v-model="radio1">
                            <el-radio-button label="最近15日"></el-radio-button>
                            <el-radio-button label="本月"></el-radio-button>
                        </el-radio-group>
                    </div>

                    <div style="padding: 0px 0; text-align: center; font-weight: bold">
                        <div id="main" style="width: 100%; height: 220px">

                        </div>
                    </div>
                </el-card>
            </el-col>

            <el-col :span="12" v-loading="getDevice_loading">
                <el-card style="color: #409EFF">
                    <div
                        style="margin-bottom: 20px;text-align: center;border-bottom: 1px solid #409EFF;padding:0 0 10px 0">
                        <i class="el-icon-money" style="float: left;font-size: 22px"/>
                        <span>设备状况</span>
                        <i class="el-icon-refresh hover" style="float: right !important;font-size: 22px"
                           @click="getDevices(current_project.id)"/>
                    </div>

                    <!--                    <div style="margin-bottom: 20px"><i class="el-icon-money"/> 设备状况</div>-->
                    <div style="padding: 10px 0; ">
                        <div style="width: 100%; height: 248px" @click="goto_map">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <!--                                    <el-card shadow="always" style="height: 90px;background-color: #409EFF;color: white"
                                                                             >
                                                                            总设备数:{{ device_num }}
                                                                        </el-card>-->
                                    <el-card shadow="hover" style="color: #409EFF">
                                        <div><i class="el-icon-s-operation"/>设备总数</div>
                                        <div style="padding: 10px 0; text-align: center; font-weight: bold">
                                            {{ device_num }}台
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12" style="margin-bottom: 15px">
                                    <!--                                    <el-card shadow="always"
                                                                                 style="height: 90px;background-color: #42b983;color: rgb(255,255,255)">
                                                                            亮灯数:{{ lighton_num }}
                                                                        </el-card>-->
                                    <el-card shadow="hover" style="color: #409EFF">
                                        <div><i class="el-icon-open"/> 漏保开关</div>
                                        <div style="padding: 10px 0; text-align: center; font-weight: bold">
                                            总数:{{ switch_num }} | 在线:{{ switch_online_num }} | 开闸:{{ switch_on_num }}
                                        </div>
                                    </el-card>
                                </el-col>


                                <el-col :span="12">
                                    <!--                                    <el-card shadow="always"
                                                                                 style="height: 90px;background: rgba(26,225,229,0.85);color: white"
                                                                                >
                                                                            在线数:{{ online_num }}
                                                                        </el-card>-->
                                    <el-card shadow="hover" style="color: #409EFF">
                                        <div><i class="el-icon-sunny"/> 灯具设备</div>
                                        <div style="padding: 10px 0; text-align: center; font-weight: bold">
                                            总数:{{ light_num }} | 在线:{{ light_online_num }} | 开灯:{{ light_on_num }}
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12">

                                    <el-card shadow="hover" style="color: #409EFF">
                                        <div><i class="el-icon-alarm-clock"/> 报警消息</div>
                                        <div style="padding: 10px 0; text-align: center; font-weight: bold">
                                            {{ tableData.length }}条
                                        </div>
                                    </el-card>
                                </el-col>

                                <!--                                <el-col :span="12">
                                                                    <el-card shadow="hover" style="color: #409EFF">
                                                                        <div><i class="el-icon-magic-stick"/> 设备在线率</div>
                                                                        <div style="padding: 10px 0; text-align: center; font-weight: bold">
                                                                            {{ lighton_num }}
                                                                        </div>
                                                                    </el-card>
                                                                </el-col>-->
                            </el-row>

                        </div>
                    </div>


                </el-card>
            </el-col>
        </el-row>

        <!--        <el-row :gutter="10" style="margin-bottom: 10px">
                    <el-col :span="24">
                        <el-card style="color: #409EFF">
                            <div style="margin-bottom: 20px"><i class="el-icon-notebook-1"/>设施信息</div>
                            <div id="pie" style="width: 100%; height: 200px"></div>
                        </el-card>
                    </el-col>


                </el-row>-->

        <el-row :gutter="10" style="margin-bottom: 10px">
            <el-col :span="6">

                <el-card style="color: #409EFF;">
                    <div
                        style="margin-bottom: 20px;text-align: center;border-bottom: 1px solid #409EFF;padding:0 0 10px 0">
                        <i class="el-icon-cpu" style="float: left;font-size: 22px"/>
                        <span>项目总耗能</span>
                        <!--                        <i class="el-icon-refresh" style="float: right !important;font-size: 22px"/>-->
                    </div>
                    <div id="pie" style="width: 100%; height: 240px;padding-top: 20px">
                        <el-card shadow="hover"
                                 style="height: 180px;width: 180px;background-color: #409EFF;color: white;margin: 20px auto;border-radius: 90px;text-align: center;line-height: 130px">
                            累计用电:{{ total_power }}kw
                        </el-card>

                    </div>
                </el-card>
            </el-col>

            <el-col :span="8" v-loading="getWarn_loading">
                <el-card style="color: #409EFF;">
                    <div
                        style="margin-bottom: 20px;text-align: center;border-bottom: 1px solid #409EFF;padding:0 0 10px 0">
                        <i class="el-icon-alarm-clock" style="float: left;font-size: 22px"/>
                        <span>警报消息</span>
                        <i class="el-icon-refresh" @click="getWarn(current_project.id)"
                           style="float: right !important;font-size: 22px"/>
                    </div>
                    <div style="width: 100%; height: 240px">
                        <el-table
                            :data="tableData"
                            show-overflow-tooltip="true"
                            height="250"
                            :header-cell-style="{'text-align':'center'}"
                            border
                            @row-click="rowClick"
                            style="width: 100%">
                            <el-table-column
                                align="center"
                                prop="no"
                                label="设备ID"
                                width="120">
                            </el-table-column>

                            <el-table-column
                                align="left"
                                show-overflow-tooltip
                                prop="mes"
                                label="报警内容"
                                width="220">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="time"
                                :formatter="getdate"
                                label="时间">
                            </el-table-column>
                        </el-table>

                    </div>
                </el-card>
            </el-col>
            <el-col :span="10" v-loading="getSumTime_loading">
                <el-card style="color: #409EFF;">
                    <div
                        style="margin-bottom: 20px;text-align: center;border-bottom: 1px solid #409EFF;padding:0 0 10px 0">
                        <i class="el-icon-picture-outline-round" style="float: left;font-size: 22px"/>
                        <span>项目所在地环境</span>
                        <!--                        <i class="el-icon-refresh" style="float: right !important;font-size: 22px"/>-->
                    </div>
                    <div style="width: 100%; height: 240px;">
                        <el-row :gutter="10">

                            <el-col :span="8">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/太阳_sun.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span style="margin-top: 15px">白天:{{ first_day_weather.text_day }}</span>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/月亮_moon.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span>夜间:{{ first_day_weather.text_night }}</span>
                                </el-card>
                            </el-col>

                            <el-col :span="8">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/日出_sunrise.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span>日出日落:{{ current_project.suntime }}</span>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" style="margin-top: 10px">
                            <el-col :span="6">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/wendu.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span
                                        style="margin-top: 5px">温度:{{ first_day_weather.low }}~{{
                                            first_day_weather.high
                                        }}度</span>
                                </el-card>
                            </el-col>
                            <el-col :span="6">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/shidu.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span style="margin-top: 15px">湿度:{{ first_day_weather.humidity }}</span>
                                </el-card>
                            </el-col>

                            <el-col :span="6">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/风向.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span>{{ first_day_weather.wind_direction }}风,{{
                                            first_day_weather.wind_scale
                                        }}级</span>
                                </el-card>
                            </el-col>
                            <el-col :span="6">
                                <el-card shadow="hover" style="text-align: center">
                                    <img src="../assets/home/降雨量.png" class="image"
                                         style="display:block;margin: auto;width: 40px;height: 40px">
                                    <span>降雨率:{{ first_day_weather.precip }}%</span>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-col>

        </el-row>


    </div>
</template>


<script>
import * as echarts from 'echarts'
import axios from "axios";
import SockJS from  'sockjs-client';
import  Stomp from 'stompjs';

export default {
    name: "Home",
    data() {
        return {
            user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
            project: '',
            current_project: '',
            projectName: '',
            projectAddress: '',

            device_num: 0,
            light_num: 0,
            switch_num: 0,

            online_num: 0,
            light_online_num: 0,
            switch_online_num: 0,

            lighton_num: 0,
            light_on_num: 0,
            switch_on_num: 0,

            total_power: 0,
            getDevice_loading: true,
            getWarn_loading: true,
            getSumTime_loading: true,
            page_loading: true,
            weather: '',
            first_day_weather: '',
            tableData: [],
            category_option: {},
            radio1: '最近15日',
            radio2: '本月',
            radio3: '上月',
            radio4: '上海',
            websocket:'',
            stompClient:''
        }
    },
    created() {
        this.load()
    },
    mounted() {  // 页面元素渲染之后再触发
        this.category_option = {

            tooltip: {
                trigger: 'item'
            },

            xAxis: {
                type: 'category',
                //data: ["2022-01-01", "2022-01-02", "2022-01-03", "2022-01-04", "2022-01-05", "2022-01-06", "2022-01-07"]
            },
            yAxis: {
                type: 'value'

            },
            series: [
                {
                    name: this.current_project.projectName,
                    data: [],
                    type: 'bar',
                    itemStyle: {
                        color: '#409EFF'
                    },
                }
            ]
        };


        this.request.get("/echarts/members").then(res => {
            //this.request.get("/project/members").then(res => {
            // 填空
            // option.xAxis.data = res.data.x


        })

        //this.connectWebsocket();
    },
    beforeDestroy(){

    },
    destroyed(){
        console.log("destroyed")
       // this.websocket.close()
    },
    methods: {
        async load() {
            this.page_loading = true
            this.request.get("/project/findByUser/" + this.user.id, {}).then(res => {
                console.log(res.data.length)
                if(res.data.length==0){//用户当前没有项目

                    sessionStorage.setItem('ownPro', "0")

                    this.page_loading = false

                    this.$confirm('请先新建一个项目', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton:false,
                        type: 'primary'
                    }).then(() => {
                        this.goto_project()
                    }).catch(() => {

                    });
                }else{
                    sessionStorage.setItem('ownPro', "1")

                    this.project = res.data
                    this.current_project = res.data[0]
                    this.projectName = res.data[0].projectName
                    this.projectAddress = res.data[0].address
                    this.weather = JSON.parse((res.data[0].weather + ""))
                    //console.log(this.weather.results[0].daily)
                    this.first_day_weather = this.weather.results[0].daily[0]
                    //console.log(this.first_day_weather)
                    this.getDevices(res.data[0].id)
                    this.getWarn()
                    this.getPowerWeek()
                    this.get_SunTime()
                    this.getAllPower()
                    this.page_loading = false
                }

            })

        },
        getDevices(v) {
            this.device_num = 0
            this.light_num = 0
            this.switch_num = 0

            this.online_num = 0,
            this.light_online_num = 0,
            this.switch_online_num = 0,

            this.lighton_num = 0,
            this.light_on_num = 0,
            this.switch_on_num = 0,

            this.getDevice_loading = true
            this.request.get("/devices/findByPid", {
                params: {
                    pid: v,
                    tid: ''
                }
            }).then(res => {
                console.log(res.data)
                this.getDevice_loading = false
                this.device_num = res.data.device.length
                this.online_num = res.data.online
                this.lighton_num = res.data.lightOn

                let dData = res.data.device
                for (let i = 0; i < dData.length; i++) {
                    if (dData[i].type == 'light' || dData[i].type == 'multi') {
                        this.light_num = this.light_num + 1
                        if (dData[i].online) {
                            this.light_online_num = this.light_online_num + 1
                        }
                        if (dData[i].light_on) {
                            this.light_on_num = this.light_on_num + 1
                        }

                    } else {
                        this.switch_num = this.switch_num + 1
                        if (dData[i].online) {
                            this.switch_online_num = this.switch_online_num + 1
                        }
                        if (dData[i].light_on) {
                            this.switch_on_num = this.switch_on_num + 1
                        }
                    }
                }
            })

        },

        getPowerWeek() {
            this.request.get("/project/findPowerById/" + this.current_project.id, {}).then(res => {

                this.category_option.xAxis.data = res.data.date.reverse()
                this.category_option.series[0].data = res.data.power.reverse()
                var chartDom = document.getElementById('main');
                var myChart = echarts.init(chartDom);
                // 数据准备完毕之后再set
                myChart.setOption(this.category_option);
            })

        },

        getAllPower() {
            this.request.get("/project/findProjectSumPowerById/" + this.current_project.id, {}).then(res => {
                console.log('total_power',res)
                let data = (res.data)
                console.log('total_power',data.power)
                this.total_power = data.power
            })

        },

        get_SunTime() {

            this.getSumTime_loading = true
            this.request.get("/sunTime/getToday", {
                params: {
                    address: this.current_project.address
                }
            }).then(res => {
                this.getSumTime_loading = false
                console.log(res)
                this.current_project.suntime = res.data.suntime.split("-")[0] + "-" + res.data.suntime.split("-")[1]

            })
        },
        getWarn() {
            console.log('获取警报消息')
            this.getWarn_loading = true
            this.request.get("/project/findWarnById/" + this.current_project.id, {}).then(res => {
                this.getWarn_loading = false
                console.log(res)
                let data = JSON.parse(res.data)
                console.log(data)
                if (data.data == null || data.data.length == 0) {
                    this.tableData = []
                } else {
                    this.tableData = data.data

                }

            })

        },
        goto_map() {
            sessionStorage.setItem('project', JSON.stringify(this.current_project))
            this.$router.push({path: '/map'});

        },
        goto_project() {

            this.$router.push({path: '/project'});

        },
        show() {
            console.log(123)
            this.$router.push("/show")
        },
        rowClick(row, event, column) {
            console.log(row)
            console.log(event)
            console.log(column)
        },
        getdate(value) {
            var now = new Date(value.time * 1000),
                y = now.getFullYear(),
                m = now.getMonth() + 1,
                d = now.getDate();
            return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
        },
        dataFormat(value) {
            let v = value.time.toString() + "000"
            let year = v.substr(0, 4);
            let month = v.substr(5, 2)
            let day = v.substr(8, 2)
            let hour = v.substr(11, 2)
            let min = v.substr(14, 2)
            let second = v.substr(17, 2)
            //return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
            return year + "-" + month + "-" + day
        },
        handleCommand(command) {
            this.$message('切换项目: ' + this.project [command].projectName);
            this.current_project = this.project [command]

            this.projectName = this.project [command].projectName
            this.projectAddress = this.project [command].address

            this.weather = JSON.parse((this.project[command].weather + ""))
            //console.log(this.weather.results[0].daily)
            this.first_day_weather = this.weather.results[0].daily[0]

            this.getDevices(this.project [command].id)
            this.getWarn()
            this.getPowerWeek()
            this.get_SunTime()
            this.getAllPower()
            //console.log(this.first_day_weather)
        },

        connectWebsocket() {
            // 建立连接对象
            this.socket = new SockJS('http://localhost:9090/myUrl');//连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
            // 获取STOMP子协议的客户端对象
            this.stompClient = Stomp.over(this.socket);
            // 定义客户端的认证信息,按需求配置
            var headers = {
                login: 'mylogin',
                passcode: 'mypasscode',
                // additional header
                'client-id': 'my-client-id'
            };
            // 向服务器发起websocket连接
            this.stompClient.connect(headers,(frame) => {
                this.stompClient.subscribe('/topic/chat_msg', (msg) => { // 订阅服务端提供的某个topic
                    consolel.log(msg.body);  // msg.body存放的是服务端发送给我们的信息
                });
            }, (err) => {
                // 连接发生错误时的处理函数
                console.log(err);
            });


            // 建立连接对象
           /* let socket = new SockJS('http://localhost:9090/myUrl?token=4567');*/
          /*  let socket =  new SockJS('http://localhost:9090'+'/myUrl' + '?token=4567');
            // 获取STOMP子协议的客户端对象
            this.stompClient = Stomp.over(socket);
            // 定义客户端的认证信息,按需求配置
            let headers = {
                Authorization:''
            }
            // 向服务器发起websocket连接
            this.stompClient.connect(headers,() => {
                this.stompClient.subscribe('/topic/user', (msg) => { // 订阅服务端提供的某个topic
                    console.log('广播成功')
                    console.log(msg);  // msg.body存放的是服务端发送给我们的信息
                },headers);
               /!* this.stompClient.send("/app/chat.addUser",
                    headers,
                    JSON.stringify({sender: '',chatType: 'JOIN'}),
                )   //用户加入接口*!/
            }, (err) => {
                // 连接发生错误时的处理函数
                console.log('失败')
                console.log(err);
            });*/

        }
    }

}
</script>

<style scoped>

</style>

